import axios from 'axios';

// Use the shared Axios instance configured in index.js, including authorization.
const path = id => `/api/running/${encodeURIComponent(id)}`;
export const getDelivery = async (id, config) => (await axios.get(`${path(id)}/delivery`, config)).data;
export const recordDelivery = async (id, payload) => (await axios.post(`${path(id)}/delivery`, payload)).data;
export const reviewDelivery = async (id, payload) => (await axios.patch(`${path(id)}/delivery-review`, payload)).data;
